// // import React, { useEffect, useState } from "react";
// // import Header from "../components/Header";
// // import { loaderStore } from "../Utils/lodaerStore";
// // const Layout = ({ children }) => {
// //   const [isLoading, setIsLoading] = useState(loaderStore.getIsLoading());

// //   useEffect(() => {
// //     const unsubscribe = loaderStore.subscribe(setIsLoading);
// //     return unsubscribe;
// //   }, []);
// //   return (
// //     <div className="App">
// //       <app-main _nghost-serverapp-c45>
// //         <Header />
// //         <div
// //           style={{
// //             position: "fixed",
// //             top: 0,
// //             left: 0,
// //             height: "100vh",
// //             width: "100vw",
// //             backgroundColor: "transparent",
// //             zIndex: 9999,
// //             cursor: "not-allowed",
// //             display: isLoading ? "block" : "none",
// //           }}
// //         />
// //         <div
// //           _ngcontent-serverapp-c45
// //           apptheme
// //           className="over-wrap loading-overlay"
// //           style={{ display: isLoading ? "block" : "none", position: "fixed" }}
// //         >
// //           <div
// //             _ngcontent-serverapp-c45
// //             id="loading"
// //             className="loading-wrap"
// //             style={{ display: "block" }}
// //           >
// //             <ul _ngcontent-serverapp-c45 className="loading">
// //               <li _ngcontent-serverapp-c45>
// //                 <img
// //                   _ngcontent-serverapp-c45
// //                   src="/assets/images/loading40.gif"
// //                   className="loaderclass"
// //                 />
// //               </li>

// //               <li _ngcontent-serverapp-c45>Loading... </li>
// //               <br _ngcontent-serverapp-c45 />
// //               <li _ngcontent-serverapp-c45>
// //                 <span _ngcontent-serverapp-c45 id="progress" />
// //               </li>
// //             </ul>
// //           </div>
// //         </div>

// //         <div _ngcontent-serverapp-c45 className="content-wrapper">
// //           {children}
// //         </div>
// //       </app-main>
// //     </div>
// //   );
// // };

// // export default Layout;

// import React, { useEffect, useState } from "react";
// import Header from "../components/Header";
// import { loaderStore } from "../Utils/lodaerStore";
// import { isMobile } from "react-device-detect";

// const getViewport = () => {
//   const vv = window.visualViewport;
//   return vv
//     ? {
//         top: vv.offsetTop,
//         left: vv.offsetLeft,
//         width: vv.width,
//         height: vv.height,
//         scale: vv.scale,
//       }
//     : {
//         top: 0,
//         left: 0,
//         width: window.innerWidth,
//         height: window.innerHeight,
//         scale: 1,
//       };
// };

// // Tracks the area of the page the user is currently looking at
// // (changes on pinch-zoom and on panning while zoomed)
// const useVisualViewport = (active) => {
//   const [vp, setVp] = useState(getViewport);

//   useEffect(() => {
//     if (!active) return;
//     const vv = window.visualViewport;
//     const update = () => setVp(getViewport());
//     update();
//     vv?.addEventListener("resize", update);
//     vv?.addEventListener("scroll", update);
//     return () => {
//       vv?.removeEventListener("resize", update);
//       vv?.removeEventListener("scroll", update);
//     };
//   }, [active]);

//   return vp;
// };

// const Layout = ({ children }) => {
//   const [isLoading, setIsLoading] = useState(loaderStore.getIsLoading());
//   const vp = useVisualViewport(isLoading);

//   useEffect(() => {
//     const unsubscribe = loaderStore.subscribe(setIsLoading);
//     return unsubscribe;
//   }, []);

//   // Overlay sized and positioned to the visible area only
//   const overlayStyle = {
//     position: "fixed",
//     top: vp.top,
//     left: vp.left,
//     width: vp.width,
//     height: vp.height,
//   };

//   const loaderScale = (isMobile ? 0.6 : 1) / vp.scale; // 0.7 = 70% size on mobile
//   return (
//     <div className="App">
//       <app-main>
//         <Header />

//         {/* click blocker */}
//         <div
//           style={{
//             ...overlayStyle,
//             backgroundColor: "transparent",
//             zIndex: 9999,
//             cursor: "not-allowed",
//             display: isLoading ? "block" : "none",
//           }}
//         />

//         {/* loader, fixed at 20% from the top of the visible area */}
//         <div
//           className="over-wrap loading-overlay"
//           style={{
//             ...overlayStyle,
//             zIndex: 10000,
//             display: isLoading ? "block" : "none",
//           }}
//         >
//           <div
//             style={{
//               position: "absolute",
//               top: isMobile ? "10%" : "20%",
//               left: "50%",
//               transform: `translateX(-50%) scale(${loaderScale})`,
//               transformOrigin: "top center", // keeps the top edge at 20% when counter-scaling
//             }}
//           >
//             <div
//               id="loading"
//               className="loading-wrap"
//               style={{ display: "block" }}
//             >
//               <ul className="loading">
//                 <li>
//                   <img
//                     src="/assets/images/loading40.gif"
//                     className="loaderclass"
//                     alt=""
//                   />
//                 </li>
//                 <li>Loading... </li>
//                 <br />
//                 <li>
//                   <span id="progress" />
//                 </li>
//               </ul>
//             </div>
//           </div>
//         </div>

//         <div className="content-wrapper">{children}</div>
//       </app-main>
//     </div>
//   );
// };

// export default Layout;

import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import { loaderStore } from "../Utils/lodaerStore";
import { isMobile } from "react-device-detect";

const MOBILE_LOADER_SIZE = 0.5;
const getViewport = () => {
  if (typeof window === "undefined") {
    return { top: 0, left: 0, width: 0, height: 0, scale: 1 };
  }
  const vv = window.visualViewport;
  return vv
    ? {
        top: vv.offsetTop,
        left: vv.offsetLeft,
        width: vv.width,
        height: vv.height,
        scale: vv.scale,
      }
    : {
        top: 0,
        left: 0,
        width: window.innerWidth,
        height: window.innerHeight,
        scale: 1,
      };
};

// Tracks the area of the page the user is currently looking at
// (changes on pinch-zoom and on panning while zoomed)
const useVisualViewport = (active) => {
  const [vp, setVp] = useState(getViewport);

  useEffect(() => {
    if (!active) return;
    const vv = window.visualViewport;
    const update = () => setVp(getViewport());
    update();
    vv?.addEventListener("resize", update);
    vv?.addEventListener("scroll", update);
    window.addEventListener("resize", update); // fallback when visualViewport is missing
    return () => {
      vv?.removeEventListener("resize", update);
      vv?.removeEventListener("scroll", update);
      window.removeEventListener("resize", update);
    };
  }, [active]);

  return vp;
};

const Layout = ({ children }) => {
  const [isLoading, setIsLoading] = useState(loaderStore.getIsLoading());
  const vp = useVisualViewport(isLoading);

  useEffect(() => {
    const unsubscribe = loaderStore.subscribe(setIsLoading);
    return unsubscribe;
  }, []);

  // Horizontal: full page width, so the loader is always centered
  // Vertical: follows the visible area, so 20% from top stays on screen
  const overlayStyle = {
    position: "fixed",
    top: vp.top,
    left: vp.left,
    width: vp.width,
    height: vp.height,
  };
  // Dividing by the zoom level keeps the loader the same size on screen
  const loaderScale = (isMobile ? MOBILE_LOADER_SIZE : 1) / vp.scale;

  return (
    <div className="App">
      <app-main>
        <Header />

        {/* click blocker */}
        <div
          style={{
            ...overlayStyle,
            backgroundColor: "transparent",
            zIndex: 9999,
            cursor: "not-allowed",
            display: isLoading ? "block" : "none",
          }}
        />

        {/* loader overlay */}
        <div
          className="over-wrap loading-overlay"
          style={{
            ...overlayStyle,
            zIndex: 10000,
            display: isLoading ? "block" : "none",
          }}
        >
          <div
            id="loading"
            className="loading-wrap"
            style={{
              display: "block",
              position: "absolute",
              top: isMobile ? "10%" : " 25%",
              left: "50%",
              marginLeft: -95, // half of the 190px width from .loading-wrap
              transform: `scale(${loaderScale})`,
              transformOrigin: "top center", // keeps top at 20% while scaling
            }}
          >
            <ul className="loading">
              <li>
                <img
                  src="/assets/images/loading40.gif"
                  className="loaderclass"
                  alt=""
                />
              </li>
              <li>Loading... </li>
              <br />
              <li>
                <span id="progress" />
              </li>
            </ul>
          </div>
        </div>

        <div className="content-wrapper">{children}</div>
      </app-main>
    </div>
  );
};

export default Layout;
